(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lw-manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.documentElement;
    if (!root.classList.contains('lw-motion')) return;

    function words(heading) {
      var text = heading.textContent.trim();
      heading.setAttribute('aria-label', text);
      heading.textContent = '';
      text.split(/\s+/).forEach(function (word, i) {
        var span = document.createElement('span');
        span.className = 'lw-manifesto__word';
        span.setAttribute('aria-hidden', 'true');
        span.style.setProperty('--lw-w', i);
        span.textContent = word;
        if (i > 0) heading.appendChild(document.createTextNode(' '));
        heading.appendChild(span);
      });
    }

    function count(el) {
      var text = el.textContent;
      var match = text.match(/\d+(?:\.\d+)?/);
      if (!match) return;
      var target = parseFloat(match[0]);
      var decimals = (match[0].split('.')[1] || '').length;
      var before = text.slice(0, match.index);
      var after = text.slice(match.index + match[0].length);
      var start = null;
      var duration = 1400;
      function frame(now) {
        if (start === null) start = now;
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = before + (target * eased).toFixed(decimals) + after;
        if (t < 1) requestAnimationFrame(frame);
      }
      el.textContent = before + (0).toFixed(decimals) + after;
      requestAnimationFrame(frame);
    }

    document.querySelectorAll('.lw-manifesto').forEach(function (section) {
      var heading = section.querySelector('.lw-manifesto__heading');
      if (heading) words(heading);

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          section.classList.add('is-drawn');
          section.querySelectorAll('[data-lw-count]').forEach(count);
          io.disconnect();
        });
      }, { threshold: 0.3 });
      io.observe(section.querySelector('.lw-manifesto__stats') || section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lw-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lw-tabs')) {
    customElements.define('lw-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tablist = this.querySelector('[role="tablist"]');
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[data-lw-tab]')];
        if (!this.tablist || this.tabs.length < 2) return;

        this.panels.forEach((panel) => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', panel.dataset.lwTab);
          panel.setAttribute('tabindex', '0');
        });
        this.tablist.hidden = false;
        this.classList.add('is-tabbed');

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i, false));
          tab.addEventListener('keydown', (event) => this.onKey(event, i));
        });

        // The theme editor selects a block: show its panel.
        this.panels.forEach((panel, i) => {
          panel.addEventListener('shopify:block:select', () => this.select(i, false));
        });

        const start = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        this.select(start < 0 ? 0 : start, false, true);
      }

      onKey(event, i) {
        const last = this.tabs.length - 1;
        const next = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: last }[event.key];
        if (next === undefined) return;
        event.preventDefault();
        this.select((next + this.tabs.length) % this.tabs.length, true);
      }

      select(index, focus, initial) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', String(on));
          tab.tabIndex = on ? 0 : -1;
          if (on && focus) tab.focus();
        });
        this.panels.forEach((panel, i) => {
          const on = i === index;
          panel.hidden = !on;
          if (on && !initial) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
